module.exports = __webpack_public_path__ + "1791188489487/images/doc.52186d4.svg";